import api from '@/apis'

export default {
  state: {
    ai: {
      loading: false,
      url: null
    },
    live: {
      loading: false,
      urls: []
    },
    mall: {
      loading: false,
      url: null
    }
  },
  mutations: {
    SET_SHOP_AI_LOADING(state, payload) {
      state.ai.loading = payload
    },
    SET_SHOP_AI_URL(state, payload) {
      state.ai.url = payload
    },
    SET_SHOP_LIVE_LOADING(state, payload) {
      state.live.loading = payload
    },
    SET_SHOP_LIVE_URLS(state, payload) {
      state.live.urls = payload
    },
    SET_SHOP_MALL_LOADING(state, payload) {
      state.mall.loading = payload
    },
    SET_SHOP_MALL_URL(state, payload) {
      state.mall.url = payload
    }
  },
  actions: {
    async fetchShopSpeech({ commit }) {
      try {
        const response = await api.getShopSpeech()
        if (response.data.success) {
          if (response.data.data.speech || response.data.data.speech_url) commit('INIT_AVATAR_SPEECH', { speech: response.data.data.speech, speech_url: response.data.data.speech_url })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async fetchShopAiUrl({ commit }) {
      try {
        commit('SET_SHOP_AI_LOADING', true)

        const response = await api.getShopAiUrl()
        if (response.data.success) {
          commit('SET_SHOP_AI_URL', response.data.data.url)
          if (response.data.data.speech || response.data.data.speech_url) commit('INIT_AVATAR_SPEECH', { speech: response.data.data.speech, speech_url: response.data.data.speech_url })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_SHOP_AI_LOADING', false)
      }
    },
    async fetchShopLiveUrls({ commit }) {
      try {
        commit('SET_SHOP_LIVE_LOADING', true)

        const response = await api.getShopLiveUrls()
        if (response.data.success) {
          commit('SET_SHOP_LIVE_URLS', response.data.data.urls)
          if (response.data.data.speech || response.data.data.speech_url) commit('INIT_AVATAR_SPEECH', { speech: response.data.data.speech, speech_url: response.data.data.speech_url })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_SHOP_LIVE_LOADING', false)
      }
    },
    async fetchShopMallUrl({ commit }) {
      try {
        commit('SET_SHOP_MALL_LOADING', true)

        const response = await api.getShopMallUrl()
        if (response.data.success) {
          commit('SET_SHOP_MALL_URL', response.data.data.url)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_SHOP_MALL_LOADING', false)
      }
    }
  }
}
